import { z } from 'zod';
import { objectIdSchema } from './objectId';

export const AccessLevel = ['brand', 'property'] as const;

export const AccessSchema = z.object({
  level: z.enum(AccessLevel),
  access: objectIdSchema.array(),
});
